import { useState } from 'react';

import { Button, IframeModal } from '@suntex.fim/ui';

export interface DirectionsButtonProps {
  url: string;
  label?: string;
}

/**
 * "Directions" button + modal for a module's how-to-play page. Shared by the
 * play page (`ModuleLayout`) and the browse catalog (`ModuleCatalog`).
 */
export function DirectionsButton({ url, label }: DirectionsButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        aria-label={label ? `Directions for ${label}` : undefined}
        intent="secondary"
        size="small"
        onClick={() => setIsOpen(true)}
      >
        Directions
      </Button>
      <IframeModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        url={url}
        title="Directions"
      />
    </>
  );
}
